import {
  AccountLoginState, QuestionsRequestVA, AccountLoginAction, ADD_TYPE_IDENTIFICATION_ANOTHER,
  ADD_GENDER_ANOTHER, ADD_FIRSTNAME_ANOTHER, ADD_LASTNAME_ANOTHER, ADD_BIRTHDATE_ANOTHER,
  ADD_IDENTIFICATION_ANOTHER, ADD_PHONE_ANOTHER, ADD_EMAIL_ANOTHER, AccountRegisterState, ADD_PASSWORD,
  ADD_USERNAME, ADD_TOKEN_RESET_PASSWORD, ADD_CITY_USER, ADD_COUNTRY_USER, AccountRecoverPasswordState
} from "./types";

const initialStateRegister: AccountRegisterState = {
  id:'',
  firstNameAnother: '',
  lastNameAnother: '',
  birthdateAnother: '',
  identificationAnother: '',
  phoneAnother: '',
  emailAnother: '',
  typeIdentificationAnother: '',
  genderAnother: '',
  birthdateAnotherDate: null,
  password: '',
  confirmationPassword: '',
  civilstatus: '',
  acceptTerms: false,
  accept_terms_and_conditions: false,
  countryAnother: '',
  cityAnother: '',
  primaryRoadUser: '',
  secondaryRoadUser: '',
  houseNumberUser: '',
  slug: '',
  step: '',
  type_beneficiary: '',
  slug_product: '',
  id_plandetailproduct: '',
  country_code: '',
  status: ''
}

export const initialStateVA: QuestionsRequestVA = {
  id:'',
  type_beneficiary: '',
  type_identification: '',
  identification: '',
  slug_product: '',
  firstname: '',
  lastname: '',
  birthdate: '',
  gender: '',
  phone: '',
  email: '',
  id_plandetailproduct: '',
  step: '',
  country_code: 'ECU',
  address: null,
  beneficiary: null,
  status: '',
};


export function accountRegisterReducer(
  state = initialStateRegister,
  action: AccountLoginAction
): AccountRegisterState {
  switch (action.type) {
    case ADD_FIRSTNAME_ANOTHER:
      return {
        ...state,
        firstNameAnother: action.payload
      };
    case ADD_LASTNAME_ANOTHER:
      return {
        ...state,
        lastNameAnother: action.payload
      };
    case ADD_IDENTIFICATION_ANOTHER:
      return {
        ...state,
        identificationAnother: action.payload
      };
    case ADD_BIRTHDATE_ANOTHER:
      return {
        ...state,
        birthdateAnother: action.payload
      };
    case ADD_PHONE_ANOTHER:
      return {
        ...state,
        phoneAnother: action.payload
      };
    case ADD_EMAIL_ANOTHER:
      return {
        ...state,
        emailAnother: action.payload
      };
    case ADD_TYPE_IDENTIFICATION_ANOTHER:
      return {
        ...state,
        typeIdentificationAnother: action.payload
      };
    case ADD_GENDER_ANOTHER:
      return {
        ...state,
        genderAnother: action.payload
      };
    case ADD_COUNTRY_USER:
      return {
        ...state,
        countryAnother: action.payload
      };
    case ADD_CITY_USER:
      return {
        ...state,
        cityAnother: action.payload
      };
    default:
      return state;
  }
}

const initialStateLogin: AccountLoginState = {
  password: '',
  username: ''
}


export function accountLoginReducer(
  state = initialStateLogin,
  action: AccountLoginAction
): AccountLoginState {
  switch (action.type) {
    case ADD_PASSWORD:
      return {
        ...state,
        password: action.payload
      };
    case ADD_USERNAME:
      return {
        ...state,
        username: action.payload
      };
    default:
      return state;
  }
}

const initialStateRecoverPassword: AccountRecoverPasswordState = {
  password: '',
  confirmationPassword: '',
  email: '',
  token: ''
}

export function accountRecoverPasswordReducer(
  state = initialStateRecoverPassword,
  action: AccountLoginAction
): AccountRecoverPasswordState {
  switch (action.type) {
    case ADD_PASSWORD:
      return {
        ...state,
        password: action.payload
      };
    case ADD_TOKEN_RESET_PASSWORD:
      return {
        ...state,
        token: action.payload
      };
    default:
      return state;
  }
}


